import introFb from "../assets/images/common/intro-fb.png"
import introTw from "../assets/images/common/intro-tw.png"
import introYt from "../assets/images/common/intro-yt.png"
import isoLogo from "../assets/images/common/iso-logo.jpg"
import ieLogo from "../assets/images/common/ie.png"
import chromeLogo from "../assets/images/common/chrome.png"
import firefoxLogo from "../assets/images/common/firefox.png"
import safariLogo from "../assets/images/common/safari.png"
import wcag2ALogo from "../assets/images/common/wcag2A.png"
import vcssLogo from "../assets/images/common/vcss.gif"

const Layoutfooter = () => {
  return (
    <section id="footer-intro">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-lg-12 col-md-12 col-xs-12">
                            <div className="land-social-menu">
                                <ul>
                                    <li><a href="https://www.facebook.com/ZPOTthailand">
                                        <img src={introFb} /></a></li>
                                    <li><a href="javascript:void(0);">
                                        <img src={introTw} /></a></li>
                                    <li><a href="https://www.youtube.com/channel/UCNzk1DCSxarciDAkYn7_gMw">
                                        <img src={introYt} /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <footer className="land-footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="standard-link non-pad-top">
                                        <ul>
                                            <li><a href="#"><img src={isoLogo} alt="iso-logo" width="98" height="94" /></a>
                                            </li>
                                            <li><div id="ipv6_enabled_www_test_logo"></div></li>
                                        </ul>

                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="land-browser">
                                        <ul>
                                            <li><img src={ieLogo} alt="ie" /></li>
                                            <li><img src={chromeLogo} alt="chrome" /></li>
                                            <li><img src={firefoxLogo} alt="firefox" /></li>
                                            <li><img src={safariLogo} alt="safari" /></li>
                                        </ul>
                                        <p>
                                            เว็บไซต์นี้แสดงผลดีที่สุดบน Google Chrome 60.0.3112.114 แสดงผลได้ทุกขนาดหน้าจอ
                                        </p>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="standard-link">
                                        <ul>
                                            <li><a href="https://www.zoothailand.org/ewt_w3c/main.php">
                                                <img src={wcag2ALogo} alt="wcag2A" /></a></li>
                                            <li><a href="https://jigsaw.w3.org/css-validator/validator?uri=http%3A%2F%2Fwww.zoothailand.org%2Fewt_w3c%2Fmain.php">
                                                <img src={vcssLogo} alt="vcss" /></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <address></address>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 footer-policy">
                                    <ul>
                                        <li><a href="https://www.zoothailand.org/policy/website_policy.pdf">นโยบายเว็บไซต์</a></li>
                                        <li><a href="https://www.zoothailand.org/policy/privacy_policy.pdf">นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a></li>
                                        <li><a href="javascript:void(0);">การปฏิเสธการรับผิดชอบ</a></li>
                                        <li><a href="https://www.zoothailand.org/policy/website_security_policy.pdf">นโยบายการรักษาความมั่นคงปลอดภัยของเว็บไซต์</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <p className="copy-text">2559 สงวนลิขสิทธิ์ตามพระราชบัญญัติลิขสิทธิ์ โดย องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์ | ผู้เข้าชมเว็บไซต์ : 4985483</p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </section>
  )
}

export default Layoutfooter